/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser($createUserInput: CreateUserInput!) {
    createUser(createUserInput: $createUserInput) {
      id
      sub
      is_deleted
      email
      display_name
      created_at
      updated_at
    }
  }
`;
export const createProject = /* GraphQL */ `
  mutation CreateProject($createProjectInput: CreateProjectInput!) {
    createProject(createProjectInput: $createProjectInput) {
      id
      is_deleted
      user_id
      sf_opportunity_id
      name
      quantity
      material_assortment_id
      items
      cost
      pathjson_url
      toolpath_url
      thumbnail_url
      nestingjson_url
      created_at
      updated_at
      material_assortment {
        id
        is_deleted
        is_available
        user_id
        material_id
        thickness
        height
        width
        unit_price
        xy_speed
        z_speed
        path_height
        rotation_speed
        created_at
        updated_at
        material {
          id
          name
          code
          texture_albedo
          texture_normal
          created_at
          updated_at
        }
      }
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($updateUserInput: UpdateUserInput!) {
    updateUser(updateUserInput: $updateUserInput) {
      id
      sub
      is_deleted
      email
      display_name
      created_at
      updated_at
    }
  }
`;
export const updateProject = /* GraphQL */ `
  mutation UpdateProject($updateProjectInput: UpdateProjectInput!) {
    updateProject(updateProjectInput: $updateProjectInput) {
      id
      is_deleted
      user_id
      sf_opportunity_id
      name
      quantity
      material_assortment_id
      items
      cost
      pathjson_url
      toolpath_url
      thumbnail_url
      nestingjson_url
      created_at
      updated_at
      material_assortment {
        id
        is_deleted
        is_available
        user_id
        material_id
        thickness
        height
        width
        unit_price
        xy_speed
        z_speed
        path_height
        rotation_speed
        created_at
        updated_at
        material {
          id
          name
          code
          texture_albedo
          texture_normal
          created_at
          updated_at
        }
      }
    }
  }
`;
export const updateCostSetting = /* GraphQL */ `
  mutation UpdateCostSetting($updateCostSettingInput: UpdateCostSettingInput!) {
    updateCostSetting(updateCostSettingInput: $updateCostSettingInput) {
      id
      user_id
      name
      cutting_cost
      burr_cost
      burr_sanding_cost
      edge_chamfering_cost
      r6mm_chamfering_cost
      r9mm_chamfering_cost
      is_burr_enabled
      is_burr_sanding_enabled
      is_edge_chamfering_enabled
      is_r6mm_chamfering_enabled
      is_r9mm_chamfering_enabled
      created_at
      updated_at
    }
  }
`;
export const updateFactorySetting = /* GraphQL */ `
  mutation UpdateFactorySetting(
    $updateFactorySettingInput: UpdateFactorySettingInput!
  ) {
    updateFactorySetting(
      updateFactorySettingInput: $updateFactorySettingInput
    ) {
      id
      user_id
      sf_cutting_place_id
      invoice_registration_number
      created_at
      updated_at
    }
  }
`;
export const updateFactoryProfile = /* GraphQL */ `
  mutation UpdateFactoryProfile(
    $updateFactoryProfileInput: UpdateFactoryProfileInput!
  ) {
    updateFactoryProfile(
      updateFactoryProfileInput: $updateFactoryProfileInput
    ) {
      id
      user_id
      name
      postal_code
      address
      location
      website
      profile_icon
      description
      pictures
      created_at
      updated_at
    }
  }
`;
export const updateMaterialAssortment = /* GraphQL */ `
  mutation UpdateMaterialAssortment(
    $updateMaterialAssortmentInput: UpdateMaterialAssortmentInput!
  ) {
    updateMaterialAssortment(
      updateMaterialAssortmentInput: $updateMaterialAssortmentInput
    ) {
      id
      is_deleted
      is_available
      user_id
      material_id
      thickness
      height
      width
      unit_price
      xy_speed
      z_speed
      path_height
      rotation_speed
      created_at
      updated_at
      material {
        id
        name
        code
        texture_albedo
        texture_normal
        created_at
        updated_at
      }
    }
  }
`;
export const storeThumbnail = /* GraphQL */ `
  mutation StoreThumbnail($storeThumbnailInput: StoreThumbnailInput!) {
    storeThumbnail(storeThumbnailInput: $storeThumbnailInput) {
      url
    }
  }
`;
export const createSFOpportunity = /* GraphQL */ `
  mutation CreateSFOpportunity($input: CreateSFOpportunityInput!) {
    createSFOpportunity(input: $input)
  }
`;
export const updateSFOpportunity = /* GraphQL */ `
  mutation UpdateSFOpportunity($input: UpdateSFOpportunityInput!) {
    updateSFOpportunity(input: $input)
  }
`;



//////////////////
// WEBPACK FOOTER
// ./src/api/graphql/mutations.ts
// module id = yJm0
// module chunks = 1